import { useEffect } from 'react';
import { authService } from '../../services/auth.service';
import { sessionService } from '../../services/session.service';
import { useAuthStore } from '../../stores/auth.store';
import { authReady } from '../../lib/firebase/auth';

export function useAuthInit() {
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    authReady.then(
      () => {
        unsubscribe = authService.onAuthStateChanged(async (firebaseUser) => {
          try {
            if (firebaseUser) {
              const adminUser = await authService.fetchAdminUser(firebaseUser.uid);
              if (adminUser && adminUser.isAdmin) {
                setUser(adminUser);
                sessionService.startSession();
                return;
              }
            }
            // Not authenticated or not admin
            setUser(null);
          } catch {
            setUser(null);
          }
        });
      },
      () => setUser(null),
    );

    return () => unsubscribe?.();
  }, [setUser]);
}
